import {Component, Inject, ViewEncapsulation} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {SyncLocal} from '@js-dot/core';
import {FormDialogBase} from './form-dialog-base';
import {FormDialogData} from './types';

export type FormDialogRef = MatDialogRef<FormDialogComponent>;

@Component({
	standalone: false,
	template: `
		<form (ngSubmit)="submit()">
			<im-dialog-area [dialog]="this"
							[heading]="data?.title"
							[description]="data?.description"
							[maximizable]="true"
							[maximize]="$$resize"
							(resized$)="$$resize = $event"
			>
				<im-mat-dynamic-controls [form]="data.form"></im-mat-dynamic-controls>
				<ng-template #_foot_>
					<button dot-link
							alias="modalSubmit"
							color="main"
							type="submit"
							[innerHTML]="'' | act:'submit'"
					>
					</button>
					<button dot-link
							alias="modalCancel"
							(click)="close()"
							[innerHTML]="'' | act:'cancel'"
					>
					</button>
				</ng-template>
			</im-dialog-area>
		</form>
	`,
	styleUrls: ['./form-dialog.scss'],
	encapsulation: ViewEncapsulation.None
})
/**
 * 폼 대화상자 컴포넌트
 */
export class FormDialogComponent extends FormDialogBase {
	// @ViewChild(DotInputsComponent) protected override _controlsPresenter;

	@SyncLocal({
		key: 'formDialogResize'
	})
	$$resize: boolean = false;

	constructor(
		dialogRef: MatDialogRef<FormDialogComponent>,
		@Inject(MAT_DIALOG_DATA) data: FormDialogData
	) {
		super(dialogRef, data);
	}
}
